import { Dropdown, Form } from "semantic-ui-react";

import React, { useState } from "react";
import { useRefinementList } from "react-instantsearch";

export default function InstantSearchAutocomplete({
	placeholder,
	value,
	onChange,
	onSelect,
	attribute = "id",
	limit = 5,
	disabled,
}) {
	const { items, searchForItems } = useRefinementList({ attribute, limit });

	const [open, setOpen] = useState(false);

	const options = items.map(({ value }) => ({
		key: value,
		text: value,
		value,
	}));

	return (
		<div className="field">
			<Dropdown
				closeOnChange
				style={{ width: "100%" }}
				trigger={<div />}
				searchInput={
					<Form.Input
						fluid
						value={value}
						placeholder={placeholder}
						disabled={attribute === "id" || disabled}
						autoComplete="off"
						onChange={(e, data) => {
							setOpen(!!data.value);

							searchForItems(data.value);

							onChange(e, data);
						}}
					/>
				}
				icon={false}
				value={false}
				options={options}
				search={(options) => options}
				selectOnNavigation={false}
				open={open && options.length > 0}
				onClose={() => setOpen(false)}
				selectOnBlur={false}
				onChange={(e, { value }) => {
					if (value && onSelect) {
						onSelect(value);
					}
				}}
			/>
		</div>
	);
}
